import { atom } from 'jotai';
const mockProductsData = [
    { productName: 'Air Zoom Pegasus 42' },
    { productName: 'Jordan 1 Low' }
];
export const linePlanEntityAtom = atom('project');
export const productsDataAtom = atom(mockProductsData);
